const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const TestPingQuery: any = {
    GetTestPingUrls: Backofficebff + '/v1/generals/get-to-ping-urls',
    PingToUrls: Backofficebff + '/v1/generals/ping-to-urls',
};
